<div class="send-email-quote-dialog">
  <div class="dialog-content">
    <h2 class="title">{{ title }}</h2>
    <div class="info" *ngIf="text">
      <p>{{ text }}</p>
    </div>
  </div>
  <div class="alert-buttons-container">
    <broker-new-button 
      [id]="'cancel'" 
      type="tertiary"
      height="medium"
      width="full-width"
      *ngIf="!isSent" 
      (clickEvent)="cancelEvent.emit()">
        {{ 'consumer.quick-quote.advice-plus.modal-buttons.cancel' | translate: lang }}
    </broker-new-button>
    <broker-new-button 
      [id]="'continue'" 
      type="primary"
      height="medium"
      width="full-width"
      [class.sent]="isSent" 
      (clickEvent)="handleSubmit()">
      <span *ngIf="!isSent">{{ 'consumer.quick-quote.advice-plus.modal-buttons.send-now' | translate: lang }}</span>
      <span *ngIf="isSent" class="sent-content">
        <broker-check-filled-svg></broker-check-filled-svg>
        {{ 'consumer.quick-quote.advice-plus.modal-buttons.sent' | translate: lang }}
      </span>
    </broker-new-button>
  </div>
</div>


